import { useState } from 'react';

function ScratchDateTimePicker({ itemKey, initialValue, update, extra }) {
	const [value, setValue] = useState(toInputValue(initialValue));

	const handleChange = (e) => {
		const newValue = e.target.value;
		setValue(newValue);
		const timestamp = newValue ? new Date(newValue).getTime() : null;
		update(itemKey, timestamp, extra);
	};

	const handleClear = () => {
		setValue('');
		update(itemKey, null, extra);
	};

	return (
		<div className="datepicker__sm">
			<input
				type="datetime-local"
				value={value}
				onChange={handleChange}
			/>
			<button
				type="button"
				onClick={handleClear}
				disabled={!value}
				aria-label="Clear date"
				className="datepicker__clear"
			>
				×
			</button>
		</div>
	);
}

function toInputValue(timestamp) {
	if (!timestamp) return '';
	const d = new Date(timestamp);
	const pad = (n) => String(n).padStart(2, '0');
	return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export default ScratchDateTimePicker;
